module.exports = __webpack_public_path__ + "static/media/logo_KI-Kurs.c2c996b5.png";